import { pickBy } from 'lodash'
import { not } from '@feedyou/utils'
import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { allQueryFilterKeys } from '../utils'
import { includeString } from '../../../lib/string'
import { useQueryParams } from '../../../components/Router/hooks/useQueryParam'
import { getDefaultDateFilterTimestamps } from '../components/Filters/DateTimeOptions/utils'

export function useQueriesFilterFromUrlQuery(params?: {
  omitQueryFilterKeys?: (keyof QueryListFilter)[]
}): QueryListFilter {
  const { omitQueryFilterKeys = [] } = params || {}
  const queryFilterKeys = allQueryFilterKeys().filter(not(includeString(omitQueryFilterKeys)))
  const { fromTimestamp: defaultFrom, toTimestamp: defaultTo } = getDefaultDateFilterTimestamps()

  const raw = useQueryParams(...queryFilterKeys)
  const parsed: Partial<QueryListFilter> = {
    userId: raw.userId ?? undefined,
    source: raw.source ?? undefined,
    searchFilter: raw.searchFilter ?? undefined,
    fromTimestamp: raw.fromTimestamp ? Number(raw.fromTimestamp) : defaultFrom,
    toTimestamp: raw.toTimestamp ? Number(raw.toTimestamp) : defaultTo,
    userRating: raw.userRating ? Number(raw.userRating) : undefined,
    customerRating: raw.customerRating ? Number(raw.customerRating) : undefined,
    adminRating: raw.adminRating ? Number(raw.adminRating) : undefined
  }

  return pickBy(parsed, v => v !== undefined)
}
